import { COUNTRIES } from "@utilities/constants"

export const getCountryWithCode = (code: string): string => {
    const country = COUNTRIES.find((country) => country.code === code);
    return country ? country.name : code;
}
